import React from 'react';
import { motion } from 'framer-motion';
import FAQCategory from './FAQCategory';
import { faqCategories } from '../../data/faq';
import { colors } from '../../styles/theme';

const FAQSection = () => {
  const handleContactClick = () => {
    window.open('https://my.europeanstudent.org/submitticket.php', '_blank');
  };

  return (
    <section className="relative py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
            <p className="text-xl text-gray-600">
              Find answers to the most common questions
            </p>
          </div>

          <motion.div 
            className="space-y-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            {faqCategories.map((category, index) => (
              <FAQCategory key={index} {...category} />
            ))}
          </motion.div>

          <div className="text-center mt-12">
            <p className="text-gray-600">
              Can't find the answer to your question?
            </p>
            <button
              onClick={handleContactClick}
              className="mt-4 px-6 py-3 rounded-lg text-white transition-all transform hover:scale-105"
              style={{ backgroundColor: colors.primary }}
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;